<script>
/**
 * 页面底部 CTA 条（自 vancheen-b2b 的 CtaBand.vue 移植为 Vue 2 版本）
 * 首页版本带 reveal 动效，内页版本无动效，用 reveal 开关区分。
 */
import NhCtaButton from './NhCtaButton.vue'

export default {
  name: 'NhCtaBand',
  components: { NhCtaButton },
  props: {
    title: { type: String, default: '' },
    desc: { type: String, default: '' },
    actions: { type: Array, default: () => [] },
    reveal: { type: Boolean, default: false }
  }
}
</script>

<template>
  <section class="cta-band">
    <div class="container">
      <div class="cta-inner">
        <div v-reveal="reveal ? '' : false">
          <h2>{{ title }}</h2>
          <p>{{ desc }}</p>
        </div>
        <div class="cta-actions" v-reveal="reveal ? 1 : false">
          <NhCtaButton
            v-for="action in actions"
            :key="action.label"
            :label="action.label"
            :to="action.to"
            :href="action.href"
            :external="action.external"
            :variant="action.cls || 'btn-light'"
          />
        </div>
      </div>
    </div>
  </section>
</template>
